<template>
  <div class="border border-primary/75 rounded p-2">
    <p>
      {{ comment.comment }}
    </p>

    <div class="flex items-center justify-between text-accent">
      <div>{{ dayjs(comment.createdAt).fromNow() }}</div>
      <div class="flex items-center">
        <button class="btn btn-sm btn-ghost flex flex-row" @click="toggleLike">
          <HeartIcon class="w-6 h-6" :class="isLiked ? 'fill-current' : 'fill-none'" />
          <div>{{ likeCount }}</div>
        </button>
        <button class="btn btn-sm btn-square btn-ghost" @click="reportComment">
          <ExclamationCircleIcon class="h-6 w-6" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type CommentModel } from '@/interfaces'
import { ExclamationCircleIcon, HeartIcon } from '@heroicons/vue/24/outline'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { onMounted, ref } from 'vue'
import { axiosInstance } from '@/utils/axios'
import { v4 } from 'uuid'
import { useI18n } from 'vue-i18n'
import { useToast } from 'vue-toast-notification'

dayjs.extend(relativeTime)

const props = defineProps<{
  comment: CommentModel
}>()

const toast = useToast({ position: 'top-right' })
const { t } = useI18n()

const isLiked = ref(false)
const likeCount = ref('')

const idCheck = () => {
  let userId = localStorage.getItem('userId')

  if (!userId) {
    const newId = v4()
    localStorage.setItem('userId', newId)
    userId = newId
  }

  return userId
}

const checkLikeCount = async () => {
  const { data } = await axiosInstance.get(`comments/${props.comment._id}`)
  if(data){
    likeCount.value = data.like_id.length
  }
}

const checkIsLiked = async () => {
  const userId = idCheck();
  const { data } = await axiosInstance.get(`comments/${props.comment._id}`)
  if (data) {
    isLiked.value = data.like_id.includes(userId)
  }
}

const toggleLike = async () => {
  const userId = idCheck();
  await axiosInstance.post(`comments/like/${props.comment._id}`, { userId })
  isLiked.value = !isLiked.value
  checkLikeCount()
}

const reportComment = () => {
  axiosInstance.post(`reports`, { comment_id: props.comment._id })

  toast.success(t('reportSent'))
}

onMounted(() => {
  checkIsLiked()
  checkLikeCount()
})
</script>
